import qs from 'qs';
import clientConfig from '../../clientConfig';
import { ClientConfig } from '../../types';

export function getPingIdentityAuthUrl(
  location?: Pick<Location, 'origin' | 'pathname'>,
): string {
  const pingIdentityAuth = (clientConfig as ClientConfig).pingIdentityAuth;

  if (!pingIdentityAuth?.enabled || !location) {
    return '';
  }

  const { origin, pathname } = location;
  const { clientId, loginHost } = pingIdentityAuth;

  const queryParams = qs.stringify(
    {
      client_id: clientId,
      redirect_uri: `${origin}/iasapi/ping/auth/`,
      state: pathname,
      response_type: 'code',
      scope: 'openid email profile',
    },
    {
      addQueryPrefix: true,
    },
  );

  return `${loginHost}${queryParams}`;
}
